import { LuminousGallery } from 'luminous-lightbox';
import 'luminous-lightbox/dist/luminous-basic.css';

/**
 * Lightbox関連 Class
 */
export default class Lightbox {
	constructor() {
		this.worksGallery();
	};

	/**
	 * 事例画像
	 */
	worksGallery(){
		new LuminousGallery(document.querySelectorAll('.is-gallery-after')); // 施工後
		new LuminousGallery(document.querySelectorAll('.is-gallery-before')); // 施工前
		new LuminousGallery(document.querySelectorAll('.is-gallery-rendering')); // 設計パース
	};
}
